export enum LoggerErrorType {
  ApolloMutation = 'apollo_mutation',
  ApolloQuery = 'apollo_query'
}
